<template>
  <!-- Main Sidebar Container -->
  <aside class="main-sidebar sidebar-dark-primary elevation-4">
    <!-- Brand Logo -->
    <a
      href="#"
      class="brand-link"
    >
      <img
        src="@/assets/AdminLTELogo.png"
        alt="Logo"
        class="brand-image img-circle elevation-3"
        style="opacity: .8"
      >
      <span class="brand-text font-weight-bold">
        SNS Posting System
      </span>
    </a>
    <!-- Sidebar -->
    <div class="sidebar">
      <!-- Sidebar Menu -->
      <nav class="mt-2">
        <ul
          class="nav nav-pills nav-sidebar flex-column"
          data-widget="treeview"
          role="menu"
          data-accordion="false"
        >
          <!-- Add icons to the links using the .nav-icon class
          with font-awesome or any other icon font library-->
          <li class="nav-item has-treeview menu-open">
            <a
              href="#"
              class="nav-link"
            >
              <i class="nav-icon fa fa-circle" />
              <p>
                Master
                <i class="right fa fa-angle-left" />
              </p>
            </a>
            <!--
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link
                  to="/D0101Demo"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon" />
                  <p>Demo</p>
                </router-link>
              </li>
            </ul>
            -->
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link
                  to="/M0001User"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon" />
                  <p>SNS User</p>
                </router-link>
              </li>
            </ul>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link
                  to="/M0002SNSLink"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon" />
                  <p>SNS Connect</p>
                </router-link>
              </li>
            </ul>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link
                  to="/M0005ScheduleList"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon" />
                  <p>SNS Schedule List</p>
                </router-link>
              </li>
            </ul>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link
                  to="/M0007SNSPostComments"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon" />
                  <p>SNS Interaction</p>
                </router-link>
              </li>
            </ul>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link
                  to="/M0006SNSReport"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon" />
                  <p>SNS Analytic Reports</p>
                </router-link>
              </li>
            </ul>
            <!--
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link
                  to="/TestPublish"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon" />
                  <p>Test Publish</p>
                </router-link>
              </li>
            </ul>-->
          </li>
          <!-- /.sidebar-menu -->
        </ul>
      </nav>
    </div>
    <!-- /.sidebar -->
  </aside>
</template>
<script>
export default {
  name: 'Sidebar',
  data: function () {
    return {}
  }
}
</script>
